import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface LoaderModel {
  name: string;
  progress: number | undefined;
}

@Injectable({
  providedIn: 'root',
})
export class LoadersService {
  private loaders: LoaderModel[] = [];
  private loaders$: BehaviorSubject<LoaderModel[]> = new BehaviorSubject<LoaderModel[]>(this.loaders);

  show(loaderName: string, progress: number | undefined = undefined): void {
    if (!loaderName || loaderName === '') {
      return;
    }
    this.loaders = [...this.loaders, { name: loaderName, progress: progress }];
    this.loaders$.next(this.loaders);
  }

  update(loaderName: string, percent: number | undefined): void {
    const index = this.loaders.findIndex((x) => x.name === loaderName);

    if (index > -1) {
      this.loaders[index].progress = percent;
      this.loaders$.next(this.loaders);
    } else {
      this.show(loaderName);
    }
  }

  hide(loaderName: string): void {
    setTimeout(() => {
      const index = this.loaders.findIndex((x) => x.name === loaderName);
      if (index > -1) {
        this.loaders.splice(index, 1);
      }
      this.loaders$.next(this.loaders);
    }, 250);
  }

  getPendingToShow(): Observable<LoaderModel[]> {
    return this.loaders$.asObservable();
  }

  isLoading(loaderName: string): boolean {
    return this.loaders.some((x) => x.name === loaderName);
  }
}
